import { render, staticRenderFns } from "./ReadOnly.vue?vue&type=template&id=04a490bf&scoped=true"
import script from "./ReadOnly.vue?vue&type=script&lang=js"
export * from "./ReadOnly.vue?vue&type=script&lang=js"
import style0 from "./ReadOnly.vue?vue&type=style&index=0&id=04a490bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a490bf",
  null
  
)

export default component.exports